// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import {
  all,
  call,
  fork,
  put,
  select,
  takeEvery,
  takeLatest,
} from 'redux-saga/effects'

import { reservasDetallesClear, setReservasDetalles } from './actions'

import {
  RESERVAS_DETALLES_CHANGE_ESTADO_SET,
  RESERVAS_DETALLES_CONFIRM_PROCESS,
  RESERVAS_DETALLES_DENY_PROCESS,
  RESERVAS_DETALLES_GET,
  RESERVAS_DETALLES_LETTER_PROCESS,
  RESERVAS_DETALLES_SET_COMENTARIO,
  RESERVAS_DETALLES_UPDATE_COMENTARIO,
  RESERVAS_DETALLES_MULTI_LETTER_PROCESS,
  RESERVAS_DETALLES_CLEAR,
  RESERVAS_DETALLES_LOADING,
  RESERVAS_DETALLES_CONFIRM_ALL,
  RESERVAS_DETALLES_CONFIRM_LOADING,
} from './types'

import { RootState } from '../../store'

import { RESERVAS_OPERACIONES_GET_BY_ESTADO } from '../reservas/types'

import {
  RESERVAS_ACTIONS_OPEN_CONFIRM,
  RESERVAS_ACTIONS_OPEN_DENY,
  RESERVAS_ACTIONS_OPEN_LETTER,
  RESERVAS_ACTIONS_IS_ALL_ACTIVE,
  RESERVAS_ACTIONS_OPEN_MULTI_LETTER,
  RESERVAS_ACTIONS_OPEN_CONFIRM_ALL,
  RESERVAS_ACTIONS_PROCESSING_LETTER,
} from '../reservasActions/type'

import { RESERVAS_ACTIONS_OPEN_COMMENT } from '../reservasActions/type'

import { notifications } from '@/common/helpers/notifications'
import {
  getReservaDetalleBy,
  postGenerarCartaReserva,
  postNegarReservas,
  postProcesarReserva,
  putReservaDetalle,
} from '@/common/helpers/reservasServices'
import { Action } from '@/common/interfaces/general'

import { ReservaDetalle } from '@/common/interfaces/reservasDetalle'
import { ReservaDetallesChangeSend } from '@/common/interfaces/sends'

function* processGetReservasDetalles({ payload }: Action<number>): any {
  const { selected } = yield select(
    (state: RootState) => state.ReservasOperaciones,
  )
  const { estados } = yield select((state: RootState) => state.Catalogos)
  const { name: estadoPath } = yield select(
    (state: RootState) => state.ReservasActions.currentPathEstado,
  )

  try {
    yield put({ type: RESERVAS_DETALLES_LOADING, payload: true })
    const data: ReservaDetalle[] = yield call(
      getReservaDetalleBy,
      payload,
      selected.EstadoId,
      estados['Reserva'],
      estadoPath,
    )

    yield put(reservasDetallesClear())
    yield put(setReservasDetalles(data))
    const changeDetalle: ReservaDetallesChangeSend[] = []

    data.forEach((rd) => {
      changeDetalle.push({
        reservaDetalleId: rd.ReservaDetalleId,
        estadoActualizadoId: rd.EstadoId,
        reservaId: rd.ReservaId,
      })
    })
    yield put({
      type: RESERVAS_DETALLES_CHANGE_ESTADO_SET,
      payload: changeDetalle,
    })
  } catch (error) {
    yield put(setReservasDetalles([]))
    notifications({ ex: error })
  } finally {
    yield put({ type: RESERVAS_DETALLES_LOADING, payload: false })
  }
}

function* denyProcess(): any {
  const { selected } = yield select(
    (state: RootState) => state.ReservasOperaciones,
  )
  const { currentPathEstado } = yield select(
    (state: RootState) => state.ReservasActions,
  )

  try {
    yield call(postNegarReservas, selected.ReservaId)
    yield put({
      type: RESERVAS_OPERACIONES_GET_BY_ESTADO,
      payload: currentPathEstado.estadosId,
    })
    yield put(reservasDetallesClear())
    yield put({ type: RESERVAS_ACTIONS_OPEN_DENY, payload: false })
    notifications({ title: 'Éxito', message: 'Negado', toastType: 'success' })
  } catch (error) {
    yield put({ type: RESERVAS_ACTIONS_OPEN_DENY, payload: false })
    notifications({ ex: error })
  }
}

function* letterProcess({ payload }: Action<boolean>): Generator {
  const { selected } = yield select(
    (state: RootState) => state.ReservasOperaciones,
  )
  const { changeDetalle } = yield select(
    (state: RootState) => state.ReservasDetalles,
  )
  const { currentPathEstado, tipo } = yield select(
    (state: RootState) => state.ReservasActions,
  )

  try {
    yield put({ type: RESERVAS_ACTIONS_PROCESSING_LETTER, payload: true })
    yield call(
      postGenerarCartaReserva,
      changeDetalle,
      tipo,
      payload,
      selected.ReservaId,
    )
    yield put(reservasDetallesClear())
    yield put({
      type: RESERVAS_OPERACIONES_GET_BY_ESTADO,
      payload: currentPathEstado.estadosId,
    })
    notifications({
      title: 'Éxito',
      message: `Carta Generada`,
      toastType: 'success',
    })
  } catch (error) {
    notifications({ ex: error })
  } finally {
    yield put({ type: RESERVAS_ACTIONS_PROCESSING_LETTER, payload: false })
    yield put({ type: RESERVAS_ACTIONS_OPEN_LETTER, payload: false })
  }
}

function* confirmProcess(): Generator {
  const { selected } = yield select(
    (state: RootState) => state.ReservasOperaciones,
  )
  const { changeDetalle } = yield select(
    (state: RootState) => state.ReservasDetalles,
  )
  const { currentPathEstado, tipo } = yield select(
    (state: RootState) => state.ReservasActions,
  )

  try {
    yield put({ type: RESERVAS_DETALLES_CONFIRM_LOADING, payload: true })
    yield call(postProcesarReserva, changeDetalle, tipo, selected.ReservaId)
    yield put(reservasDetallesClear())
    yield put({
      type: RESERVAS_OPERACIONES_GET_BY_ESTADO,
      payload: currentPathEstado.estadosId,
    })
    notifications({
      title: 'Éxito',
      message: `Confirmado`,
      toastType: 'success',
    })
  } catch (error) {
    notifications({ ex: error })
  } finally {
    yield put({ type: RESERVAS_ACTIONS_OPEN_CONFIRM, payload: false })
    yield put({ type: RESERVAS_DETALLES_CONFIRM_LOADING, payload: false })
  }
}

function* modificarComentario({ payload }: Action<string>): Generator {
  const { selected } = yield select(
    (state: RootState) => state.ReservasDetalles,
  )
  const sendData = {
    ReservaDetalleId: selected.ReservaDetalleId,
    Comentario: payload,
  }

  try {
    yield call(putReservaDetalle, selected, payload)
    yield put({ type: RESERVAS_DETALLES_UPDATE_COMENTARIO, payload: sendData })
    notifications({
      title: 'Éxito',
      message: `Se guardó el comentario`,
      toastType: 'success',
    })
  } catch (error) {
    notifications({ ex: error })
  } finally {
    yield put({ type: RESERVAS_ACTIONS_OPEN_COMMENT, payload: false })
  }
}

function* multiLetterProcess({ payload }: Action<boolean>): Generator {
  const { changeDetalle } = yield select(
    (state: RootState) => state.ReservasDetalles,
  )
  const { currentPathEstado, tipo } = yield select(
    (state: RootState) => state.ReservasActions,
  )
  const { estados } = yield select((state: RootState) => state.Catalogos)

  try {
    const newChangeSoloSolicitados = changeDetalle.filter(
      (rd: any) =>
        rd.estadoActualizadoId ===
          estados['Reserva']['Reserva Solicitada'].EstadoId ||
        rd.estadoActualizadoId ===
          estados['Reserva']['Modificación Solicitada'].EstadoId,
    )

    yield call(postGenerarCartaReserva, newChangeSoloSolicitados, tipo, payload)
    yield put({ type: RESERVAS_DETALLES_CLEAR })
    yield put({
      type: RESERVAS_OPERACIONES_GET_BY_ESTADO,
      payload: currentPathEstado.estadosId,
    })
    notifications({
      title: 'Éxito',
      message: `Se generó la carta`,
      toastType: 'success',
    })
  } catch (error) {
    notifications({ ex: error })
  } finally {
    yield put({ type: RESERVAS_ACTIONS_IS_ALL_ACTIVE, payload: false })
    yield put({ type: RESERVAS_ACTIONS_OPEN_MULTI_LETTER, payload: false })
  }
}

function* confirmAll(): Generator {
  try {
    const { estados } = yield select((state: RootState) => state.Catalogos)
    const { changeDetalle } = yield select(
      (state: RootState) => state.ReservasDetalles,
    )
    const { currentPathEstado, tipo } = yield select(
      (state: RootState) => state.ReservasActions,
    )

    yield put({ type: RESERVAS_ACTIONS_PROCESSING_LETTER, payload: true })

    // Un Set y no un arreglo: `changeDetalle` son DETALLES, y varios detalles pertenecen a la
    // misma reserva, asi que empujar `rd.reservaId` por cada uno repetia la misma reserva tantas
    // veces como detalles tuviera. Ademas de enviarla de mas, la repeticion destapaba el otro
    // defecto: `prepareParamsReserva` borraba `reservaId` de los detalles al armar el envio, asi
    // que en la segunda vuelta del mismo id el filtro ya no encontraba nada y la reserva se
    // mandaba con la lista de detalles vacia.
    const idsAconfirmar = new Set<number>()

    changeDetalle.forEach((rd: ReservaDetallesChangeSend) => {
      if (
        rd.cartaEnviada &&
        (rd.estadoActualizadoId ===
          estados['Reserva']['Reserva Solicitada'].EstadoId ||
          rd.estadoActualizadoId ===
            estados['Reserva']['Modificación Solicitada'].EstadoId ||
          rd.estadoActualizadoId === estados['Reserva']['Negado'].EstadoId)
      ) {
        idsAconfirmar.add(rd.reservaId)
      }
    })

    const reservasAconfirmar = [...idsAconfirmar]

    yield call(postProcesarReserva, changeDetalle, tipo, reservasAconfirmar)
    yield put({
      type: RESERVAS_OPERACIONES_GET_BY_ESTADO,
      payload: currentPathEstado.estadosId,
    })
    notifications({
      title: 'Éxito',
      message: `Confirmado`,
      toastType: 'success',
    })
  } catch (error) {
    notifications({ ex: error })
  } finally {
    yield put({ type: RESERVAS_ACTIONS_OPEN_CONFIRM_ALL, payload: false })
    yield put({ type: RESERVAS_ACTIONS_PROCESSING_LETTER, payload: false })
  }
}

// WATCHERS

function* watchConfirmAll(): Generator {
  yield takeLatest(RESERVAS_DETALLES_CONFIRM_ALL, confirmAll)
}

function* watchMultiLetterProcess(): Generator {
  yield takeLatest(RESERVAS_DETALLES_MULTI_LETTER_PROCESS, multiLetterProcess)
}

function* watchComment(): Generator {
  yield takeLatest(RESERVAS_DETALLES_SET_COMENTARIO, modificarComentario)
}

function* watchConfirmProcess(): Generator {
  yield takeEvery(RESERVAS_DETALLES_CONFIRM_PROCESS, confirmProcess)
}

function* watchLetterProcess(): Generator {
  yield takeEvery(RESERVAS_DETALLES_LETTER_PROCESS, letterProcess)
}

function* watchDenyProcess(): Generator {
  yield takeEvery(RESERVAS_DETALLES_DENY_PROCESS, denyProcess)
}

function* watchGetReservasDetalles(): Generator {
  // takeLatest y no takeEvery: al pasar de una reserva a otra se despacha una carga nueva sin que
  // la anterior haya terminado. Con takeEvery las dos seguian vivas y la que respondia ultimo
  // ganaba, asi que una respuesta lenta de la reserva anterior sobreescribia el detalle de la que
  // el usuario tenia seleccionada. takeLatest cancela la anterior.
  yield takeLatest(RESERVAS_DETALLES_GET, processGetReservasDetalles)
}

export default function* reservasDetallesSagas(): Generator {
  yield all([
    fork(watchGetReservasDetalles),
    fork(watchDenyProcess),
    fork(watchLetterProcess),
    fork(watchConfirmProcess),
    fork(watchComment),
    fork(watchMultiLetterProcess),
    fork(watchConfirmAll),
  ])
}
